module.exports = "https://static.energy5.com/_next/static/images/waterBg-3bd777028127b41299d16e37879fc8b5.webp";